import { Badge } from '@material-ui/core';
import { Check, HighlightOff } from "@material-ui/icons";
import { makeStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import moment from 'moment';
import Filter from "../../../assets/images/filter.svg";
import '../CollectionFiltersButtons/CollectionFiltersButtons.scss'
import Customdaterange from '../../modals/customdaterange/customdaterange';

const useStyles = makeStyles((theme) => ({
  margin: { margin: theme.spacing(2) },
  padding: { padding: theme.spacing(0, 2) },
}));

const buildInitialFilterData = (loanTypes = [], branches = []) => ({
  filter2: [
    {
      value: "0",
      label: "Custom Date",
      isActive: false,
      subList: [{ value: "date", label: "Select the Date", isActive: false }],
    },
    {
      value: "1",
      label: "Loan Type",
      isActive: false,
      subList: loanTypes,
    },
    {
      value: "branch",
      label: "Branch",
      isActive: false,
      subList: branches,
    },
    {
      value: "2",
      label: "Loan Amount Range",
      isActive: false,
      subList: [
        { value: "1-100000", label: "0 – 100,000", isActive: false },
        { value: "100001-500000", label: "100,001 – 500,000", isActive: false },
        { value: "500001-1000000", label: "500,001 – 1,000,000", isActive: false },
        { value: "1000001-2500000", label: "1,000,001 – 2,500,000", isActive: false },
        { value: "2500001-999999999", label: "Above 2,500,000", isActive: false },
      ],
    },
    {
      value: "clearall",
      label: "Clear All",
      isActive: true,
      subList: [],
    },
  ],
});

class CollectionFiltersButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      dateRange: null,
      filterData: buildInitialFilterData(props.loanTypes, props.branches),
    };
  }

  componentWillReceiveProps(nextProps) {
    const { loanTypes, branches } = nextProps;
    this.setState((prevState) => {
      const filter2 = prevState.filterData.filter2.map((item) => {
        if (item.value === "1") {
          return { ...item, subList: loanTypes || [] };
        }
        if (item.value === "branch") {
          return { ...item, subList: branches || [] };
        }
        return item;
      });

      return { filterData: { filter2 } };
    });
  }

  closeModal = () => {
    this.setState({ openModal: false });
  };

  handleDateChange = (dateRange) => {
    const hasDate = !!dateRange?.start;
    this.setState((prevState) => {
      const filter2 = prevState.filterData.filter2.map((item) => {
        if (item.value !== "0") return item;
        return {
          ...item,
          isActive: hasDate,
          subList: item.subList.map((s) =>
            s.value === "date" ? { ...s, isActive: hasDate } : s
          ),
        };
      });
      return {
        filterData: { filter2 },
        dateRange: hasDate ? dateRange : null,
        openModal: false,
      };
    });
    this.props.onDateChange(dateRange);
  };

  changeStatus = (filter, subObj, isFromSubList) => {
    const { action } = this.props;

    if (filter.value === "clearall") {
      if (this.state.dateRange) {
        this.props.onDateChange({ start: null, end: null });
      }
      this.setState((prevState) => {
        const filter2 = prevState.filterData.filter2.map((item) => {
          if (item.value === "clearall") return item;
          return {
            ...item,
            isActive: false,
            subList: item.subList.map((s) => ({ ...s, isActive: false })),
          };
        });
        return { filterData: { filter2 }, dateRange: null, openModal: false };
      });
      action({ subMenuClear: true });
      return;
    }

    if (filter.value === "0") {
      this.setState({ openModal: true });
      return;
    }

    if (isFromSubList) {
      this.setState(
        (prevState) => {
          const filter2 = prevState.filterData.filter2.map((item) => {
            if (item.value !== filter.value) return item;
            const subList = item.subList.map((s) => {
              const match = s.value === subObj.value || s.label === subObj.label;
              if (!match) return { ...s, isActive: false };
              return { ...s, isActive: !s.isActive };
            });
            return {
              ...item,
              subList,
              isActive: subList.some((s) => s.isActive),
            };
          });
          return { filterData: { filter2 } };
        },
        () => {
          const updatedFilter = this.state.filterData.filter2.find(
            (f) => f.value === filter.value
          );
          const updatedSubObj = updatedFilter?.subList.find(
            (s) => s.value === subObj.value || s.label === subObj.label
          );
          action({
            menuID: filter.value,
            subMenuID:
              subObj.loanTypeId !== undefined ? subObj.loanTypeId : subObj.value,
            subMenuActive: updatedSubObj?.isActive ?? false,
            subMenuClear: false,
          });
        }
      );
    }
  };

  render() {
    const { filterData, dateRange } = this.state;
    const filterBadgeValue = filterData.filter2.filter(
      (obj) => obj.isActive && obj.value !== "clearall"
    ).length;

    return (
      <div className="collectionfilterbuttonpage">
        <Badge color="primary" badgeContent={filterBadgeValue} />
        <div className="hoverFunction">
          <button className="filterButton">
            Filter
            <img className="filterImg" src={Filter} alt="filter" />
          </button>
          <ul className="hoverMenu" style={{zIndex: 99999}}>
            <div>
              {filterData.filter2.map((filterItem, index) => (
                <li className="menuList" key={index}>
                  <a
                    value={filterItem.value}
                    onClick={() => this.changeStatus(filterItem, null, false)}
                  >
                    {filterItem.label}
                    {filterItem.value !== "clearall" ? (
                      filterItem.isActive ? (
                        <Check className="floatRightIcon" />
                      ) : null
                    ) : (
                      <HighlightOff className="floatRightIcon" />
                    )}
                  </a>
                  {filterItem.subList && filterItem.subList.length > 0 && (
                    <ul className="subList">
                      <div style={{ maxHeight: "397px", overflowY: "scroll" }}>
                        {filterItem.subList.map((option) => (
                          <li
                            key={option.value ?? option.label}
                            value={option.label}
                            className="subListMenu"
                            onClick={() =>
                              this.changeStatus(filterItem, option, true)
                            }
                          >
                            <a value={option.value}>
                              {option.value === "date" && dateRange?.start
                                ? `${moment(dateRange.start).format("DD MMM YYYY")} - ${moment(dateRange.end).format("DD MMM YYYY")}`
                                : option.label}
                              {option.isActive ? (
                                <Check className="menuIcon" />
                              ) : null}
                            </a>
                          </li>
                        ))}
                      </div>
                    </ul>
                  )}
                </li>
              ))}
            </div>
          </ul>
        </div>
        <Customdaterange
          save={this.handleDateChange}
          open={this.state.openModal}
          close={this.closeModal}
        />
      </div>
    );
  }
}

export default CollectionFiltersButtons;
